import FrontEndStore from './FrontEndStore';

export default class ToastsStore extends FrontEndStore {
  constructor(store) {
    super();
    this.store = (store && store.store) || store || [];
    this.storeType = ToastsStore;
  }
}
